import { getMemberId } from '@trello/authentication';
import { PersistentSharedState } from '@trello/shared-state';

/*
  We store both the card ID _and_ dateLastView. This allows us to
  interleave these recent cards with recent boards
*/
export interface RecentCard {
  id: string;
  dateLastView: Date;
}

export const recentCardsState = new PersistentSharedState<RecentCard[]>([], {
  storageKey: () => `recentCardsState-${getMemberId() ?? 'anonymous'}`,
});

export const getRecentCards = () => {
  return recentCardsState.value || [];
};
export const pushRecentCard = (card: RecentCard) => {
  const MAX_CARDS_TO_PERSIST = 10;
  const recentCards = getRecentCards();
  recentCardsState.setValue(
    [
      card,
      ...recentCards.filter((recentCard) => recentCard.id !== card.id),
    ].slice(0, MAX_CARDS_TO_PERSIST),
  );
};
